@if (isOpen) {
  <div class="modal-fullscreen">
    <div class="modal-header">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">Retour</button>
      <!-- Tabs -->
      <div class="modal-tabs">
        <button class="tab" [class.active]="selectedTab === 'mytemplates'" (click)="selectTab('mytemplates')">Mes templates</button>
        <button class="tab" [class.active]="selectedTab === 'basique'" (click)="selectTab('basique')">Basique</button>
        <button class="tab" [class.active]="selectedTab === 'inspiration'" (click)="selectTab('inspiration')">Inspiration</button>
      </div>
      <!-- Search bar : l'onglet "Mes templates" a déjà la sienne dans app-template-modal -->
      <div class="search-container">
        @if (selectedTab !== 'mytemplates') {
          <input type="text"
            [ngModel]="searchQuery"
            (ngModelChange)="searchQuery = $event; onSearchChange()"
            placeholder="Rechercher un template..."
            class="search-input">
        }
      </div>
    </div>
    <div class="modal-content" (scroll)="onScroll($event)">
      <!-- My Templates -->
      @if (selectedTab === 'mytemplates') {
        <app-template-modal [inline]="true" [templates]="templates" (templateSelected)="onTemplateModalSelect($event)"></app-template-modal>
      }
      <!-- Basique Templates Placeholder -->
      @if (selectedTab === 'basique') {
        <div>
          <div class ="section-title"><strong><h6>Basique</h6></strong></div>
          <div class="template-grid">
            @for (template of filteredStripoBasicTemplates; track template.templateId) {
              <div class="template-item" (click)="selectStripoTemplate(template)">
                <img [src]="template.logo" alt="{{template.name}}">
                <p class="template-title"><strong>{{ template.name }}</strong></p>
              </div>
            }
          </div>
          @if (!filteredStripoBasicTemplates.length) {
            <div class="no-results-message">Aucun template ne correspond à votre recherche.</div>
          }
        </div>
      }
      <!-- Inspiration : catalogue Stripo complet, gratuits + premium -->
      @if (selectedTab === 'inspiration') {
        <div>
          <div class ="section-title"><strong><h6>Inspiration</h6></strong></div>

          <div class="filter-bar">
            <select class="filter-select"
              [ngModel]="selectedIndustry"
              (ngModelChange)="selectedIndustry = $event; applyInspirationFilters()">
              <option value="">Toutes les industries</option>
              @for (option of industryOptions; track option.name) {
                <option [value]="option.name">{{ option.name }} ({{ option.count }})</option>
              }
            </select>

            <select class="filter-select"
              [ngModel]="selectedType"
              (ngModelChange)="selectedType = $event; applyInspirationFilters()">
              <option value="">Tous les types</option>
              @for (option of typeOptions; track option.name) {
                <option [value]="option.name">{{ option.name }} ({{ option.count }})</option>
              }
            </select>

            <select class="filter-select"
              [ngModel]="selectedSeason"
              (ngModelChange)="selectedSeason = $event; applyInspirationFilters()">
              <option value="">Toutes les occasions</option>
              @for (option of seasonOptions; track option.name) {
                <option [value]="option.name">{{ option.name }} ({{ option.count }})</option>
              }
            </select>

            @if (hasActiveFilters) {
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="resetFilters()">Réinitialiser</button>
            }

            @if (!loadingtemplates && !catalogError) {
              <span class="filter-count">{{ filteredInspirationTemplates.length }} template(s)</span>
            }
          </div>

          @if (loadingtemplates) {
            <div class="no-results-message">Chargement du catalogue...</div>
          }
          @if (catalogError) {
            <div class="no-results-message">
              Impossible de charger le catalogue.
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="retryCatalog()">Réessayer</button>
            </div>
          }

          <div class="template-grid">
            @for (template of visibleInspirationTemplates; track template.templateId) {
              <div class="template-item" (click)="selectStripoTemplate(template)">
                @if (template.premium) {
                  <span class="premium-badge">Premium</span>
                }
                <img [src]="template.logo" alt="{{template.name}}" loading="lazy">
                <p class="template-title"><strong>{{ template.name }}</strong></p>
              </div>
            }
          </div>

          @if (!loadingtemplates && !catalogError && !filteredInspirationTemplates.length) {
            <div class="no-results-message">Aucun template ne correspond à votre recherche.</div>
          }
        </div>
      }
    </div>
  </div>
}
